import type { GetExecutionResponse } from '@blockworks/platform/api/research/studio/execution';
import {
    type GetVisualizationResponse,
    StudioVisualizationType,
} from '@blockworks/platform/api/research/studio/visualizations';

import { getCounterParameters } from './counter';
import { getPieParameters } from './pie';
import { getSankeyParameters } from './sankey';
import { getTableParameters } from './table';
import { getTimeseriesParameters } from './timeseries';

type VisualizationWithExecution = Pick<GetVisualizationResponse<any>['data'], 'config' | 'type'> & {
    execution: GetExecutionResponse['data'];
};

export const getVisualizationParameterMeta = (visualization: VisualizationWithExecution) => {
    switch (visualization.type) {
        case StudioVisualizationType.Timeseries:
            return getTimeseriesParameters(visualization);
        case StudioVisualizationType.Table:
            return getTableParameters(visualization);
        case StudioVisualizationType.Counter:
            return getCounterParameters(visualization);
        case StudioVisualizationType.Pie:
            return getPieParameters(visualization);
        case StudioVisualizationType.Sankey:
            return getSankeyParameters(visualization);
        default:
            return [];
    }
};
